<template>
  <div>
    <v-card-title class="text-center my-2">
      <!-- <span class="mx-auto">{{ $t('login.register_title') }}</span> -->
    </v-card-title>

    <v-text-field
      v-model="name"
      :error-messages="
        errors.register && errors.register.name ? errors.register.name : []
      "
      :rules="stringRule"
      append-icon="mdi-account"
      dense
      :label="$t('login.name_label')"
      outlined
      type="text"
      @keypress="preventNumericInput"
    />

    <v-text-field
      v-model="lastName"
      :error-messages="
        errors.register && errors.register.lastName
          ? errors.register.lastName
          : []
      "
      :rules="stringRule"
      append-icon="mdi-account"
      dense
      :label="$t('login.lastname_label')"
      outlined
      type="text"
      @keypress="preventNumericInput"
    />

    <div class="mb-5 pb-2">
      <TelInput
        :error-messages="
          errors.register && errors.register.phone ? errors.register.phone : []
        "
        v-model="phone"
      />
    </div>

    <v-text-field
      v-model="nid"
      :error-messages="
        errors.register && errors.register.nid ? errors.register.nid : []
      "
      append-icon="mdi-numeric"
      dense
      :label="$t('login.nid_label')"
      :maxlength="$i18n.locale === 'fa' ? 10 : 20"
      outlined
      @keypress="isNumberKey"
    />

    <v-text-field
      v-if="!invited"
      v-model="parentPhone"
      :error-messages="
        errors.register && errors.register.parentPhone
          ? errors.register.parentPhone
          : []
      "
      append-icon="mdi-phone"
      dense
      :label="$t('login.parent_phone_label')"
      maxlength="20"
      outlined
      @keypress="isNumberKey"
    />

    <v-card-subtitle class="pa-1" style="font-size: small">
      <v-checkbox v-model="rulesCheckbox" style="font-size: small">
        <template v-slot:label>
          <div
            style="font-size: small"
            @click.stop.prevent="termsDialog = true"
          >
            {{ $t("login.terms_and_conditions_message") }}
          </div>
        </template>
      </v-checkbox>
    </v-card-subtitle>

    <v-dialog
      v-model="termsDialog"
      content-class="my-custom-dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title
          class="headline"
          style="
            position: sticky;
            top: 0;
            background-color: #fff;
            color: #14182a;
            font-size: 0.9rem;
            font-family: vazir, sans-serif;
          "
        >
          {{ $t("login.terms_and_conditions_link") }}
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-2" style="color: #14182a">
          <pre style="font-family: vazir" v-html="ghavanin"></pre>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn text @click.prevent="termsDialog = false">
            {{ $t("login.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn :loading="loading" color="primary" @click="register">
      <v-icon>mdi-chevron-right</v-icon>
      {{ $t("login.register_button") }}
    </v-btn>

    <p class="d-flex d-inline justify-content-end mb-0 mt-4">
      <span class="ml-1 mt-2"> {{ $t("login.already_registered") }}</span>
      <v-btn text @click="$emit('show-login')">
        {{ $t("login.login_here") }}
      </v-btn>
    </p>
  </div>
</template>

<script>
import TelInput from "@/components/TelInput.vue";
import i18nService from "@/core/services/i18n.service";
import { ghavanin } from "./terms.js";

export default {
  name: "RegisterForm",
  components: {
    TelInput,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({ register: {} }),
    },
    invited: {
      type: Boolean,
      default: false,
    },
    initialPhone: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    locales: i18nService.languages,
    name: "",
    lastName: "",
    phone: "",
    nid: "",
    parentPhone: null,
    rulesCheckbox: false,
    termsDialog: false,
  }),
  watch: {
    initialPhone: {
      immediate: true,
      handler(newVal) {
        this.phone = newVal;
      },
    },
  },
  computed: {
    stringRule() {
      return [
        (v) => !!v || this.$t("login.required"),
        (v) => !v || v.length >= 3 || this.$t("login.min_3_char"),
        (v) => !v || v.length <= 50 || this.$t("login.max_50_char"),
      ];
    },
    ghavanin() {
      return ghavanin[this.$i18n.locale] || ghavanin.en;
    },
  },
  methods: {
    preventNumericInput($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode > 47 && keyCode < 58) {
        $event.preventDefault();
      }
    },
    isNumberKey: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    register() {
      console.log("register");
      if (!this.rulesCheckbox) {
        this.$emit("error", this.$t("login.agree_to_terms_error"));
        return;
      }

      let parentPhone = null;

      if (this.parentPhone && typeof this.parentPhone === "string") {
        let digits = this.parentPhone.replace(/\D/g, "");
        if (digits.startsWith("09") && digits.length === 11) {
          parentPhone = "98" + digits.substring(1);
        } else if (digits.startsWith("9") && digits.length === 10) {
          parentPhone = "98" + digits;
        } else if (digits.startsWith("989") && digits.length === 12) {
          parentPhone = digits;
        } else {
          parentPhone = digits;
        }
      }
      const formData = {
        name: this.name,
        lastName: this.lastName,
        phone: this.phone,
        nid: this.nid,
        parentPhone: parentPhone,
      };
      console.log(formData, "formdata");
      this.$emit("register", formData);
    },
  },
};
</script>
<style scoped>
.my-custom-dialog {
  align-self: flex-end;
}
</style>
